module.exports = __webpack_public_path__ + "static/event1-09ca432257422550380e17fd13aac86f.jpg";